<template>
  <div>
    <px-view-header title="Cadastro de catálogo" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && catalogo">

      <v-stepper class="elevation-1" v-model="currentStep" vertical>

        <v-stepper-step :complete="currentStep > 1" step="1">
          Dados básicos
        </v-stepper-step>
        <v-stepper-content step="1">
          <px-cadastro-catalogo-dados-basicos @next="next"
                                              @cancel="onClickBack"
                                              :catalogo="catalogo"/>
        </v-stepper-content>

        <v-stepper-step :complete="currentStep > 2" step="2">
          Frete
        </v-stepper-step>
        <v-stepper-content step="2">
          <px-cadastro-catalogo-frete @ready="next"
                                      @previous="previous"
                                      :loading="loadingSave"
                                      :catalogo="catalogo"/>
        </v-stepper-content>

        <v-stepper-step :complete="currentStep > 3" step="3">
          Prazos de pagamentos
        </v-stepper-step>
        <v-stepper-content step="3">
          <px-cadastro-catalogo-prazos @ready="onClickSave"
                                      @previous="previous"
                                      :loading="loadingSave"
                                      :catalogo="catalogo"/>
        </v-stepper-content>

      </v-stepper>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import validationMixin from '@/mixins/validation-mixin';
import FornecedorService from '@/api/fornecedor-service';
import { NumberUtils } from 'px-components';
import CatalogoService from './catalogo-service';
import CadastroCatalogoDadosBasicos from './CadastroCatalogoDadosBasicos.vue';
import CadastroCatalogoFrete from './CadastroCatalogoFrete.vue';
import CadastroCatalogoPrazos from './CadastroCatalogoPrazos.vue';

export default {
  mixins: [validationMixin],
  data() {
    return {
      currentStep: 1,
      loading: false,
      loadingSave: false,
      id: this.$route.params.id,
      breadcrumbs: [
        { text: 'Catálogo' },
        { text: 'Catálogos' },
        { text: 'Cadastro de Catálogo' },
      ],
      catalogo: null,
    };
  },
  computed: {
    editing() {
      return !!this.id;
    },
  },
  methods: {
    next() {
      this.currentStep += 1;
    },
    previous() {
      this.currentStep -= 1;
    },
    getFornecedor() {
      this.loading = true;
      FornecedorService.getDefault()
        .then(({ data }) => {
          this.setupCatalogo();
          this.catalogo.fornecedor = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildSave() {
      return cloneDeep(this.catalogo);
    },
    onClickBack() {
      this.$router.push({ name: 'main.catalogos' });
    },
    onClickSave() {
      this.loadingSave = true;
      CatalogoService.save(this.buildSave())
        .then(() => {
          this.$toast('Catálogo salvo', { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    setupCatalogo() {
      if (!this.catalogo) {
        this.catalogo = {
          gruposCompras: null,
          fornecedor: null,
          nome: null,
          prazosPagamentos: [],
          users: [],
          ativo: true,
          frete: {
            ofertaFreteGratis: null,
            taxaMinimaEntrega: null,
            tipoFrete: null,
            valorTaxaEntrega: null,
            prazoEmbarque: null,
          },
          ceps: [],
        };
      }
    },
    setupEditing() {
      this.loading = true;
      CatalogoService.get(this.id)
        .then(({ data }) => {
          this.catalogo = data;
          this.catalogo.frete.taxaMinimaEntrega = NumberUtils.fixNumberInput(
            this.catalogo.frete.taxaMinimaEntrega,
          );
          this.catalogo.frete.valorTaxaEntrega = NumberUtils.fixNumberInput(
            this.catalogo.frete.valorTaxaEntrega,
          );

          if (this.catalogo.prazosPagamentos) {
            this.catalogo.prazosPagamentos = this.catalogo.prazosPagamentos.map((prazo) => {
              const fixed = { ...prazo };
              fixed.valorMinimo = NumberUtils.fixNumberInput(fixed.valorMinimo);
              return fixed;
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (this.editing) {
      this.setupEditing();
      return;
    }
    this.getFornecedor();
  },
  components: {
    pxCadastroCatalogoDadosBasicos: CadastroCatalogoDadosBasicos,
    pxCadastroCatalogoFrete: CadastroCatalogoFrete,
    pxCadastroCatalogoPrazos: CadastroCatalogoPrazos,
  },
};
</script>
